import { useQuery } from '@tanstack/react-query';
import { fetchScenarioMotionPlan, type MotionPlanResponse } from '../../../../features/scenarios/api';
import { boundaryRoundingInputSignature } from '../motionBoundaryRounding';
import { isMotionEngineScenario } from '../motionScenario';
import type { Scenario } from '../types';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const motionPlanQueryKey = (scenarioId: string) => ['scenario-motion-plan', scenarioId] as const;

/**
 * 全編モーションのシナリオの計画 (GET /motion/plan・docs/features/brand-cut-motion-graphics-plan.md §10.5)。
 * BGM 欄のリンク・シーン一覧上のパネル・ブランドカットの入口で react-query のキャッシュを共有する。
 * 入力の要約 (BGM・シーンの尺 / 順序 / 動画・ナレーション尺) が変わったら取り直す。
 */
export function useMotionPlan(scenario: Scenario, options?: { refetchIntervalMs?: number | false }) {
  const enabled = isMotionEngineScenario(scenario)
    && UUID_REGEX.test(scenario.id)
    && scenario.status !== 'generating';
  const signature = boundaryRoundingInputSignature(scenario);
  return useQuery<MotionPlanResponse>({
    queryKey: [...motionPlanQueryKey(scenario.id), signature],
    queryFn: () => fetchScenarioMotionPlan(scenario.id),
    enabled,
    staleTime: 30_000,
    // 全編の生成中は途中経過 (previews) を追うために定期的に取り直す
    refetchInterval: options?.refetchIntervalMs ?? false,
  });
}
